import { render, staticRenderFns } from "./menu1.vue?vue&type=template&id=1de1f0ef"
import script from "./menu1.vue?vue&type=script&lang=js"
export * from "./menu1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports